import React from 'react';

interface LitePlanNotificationProps {
    show: boolean;
}
export function LitePlanNotification({ show }: LitePlanNotificationProps) {
    return show ? (
        <div className="h5 text-center mt-2">
            The eForm is currently unavailable as the Member’s Benefit plan is part of a Lite
            Program that does not include this service.
        </div>
    ) : null;
}
